import { Action } from "redux";

export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION";

export interface SelectOrganizationAction extends Action {
  type: typeof SELECT_ORGANIZATION;
  organizationKeyName: string;
}

export const selectOrganizationAction = (
  organizationKeyName: string
): SelectOrganizationAction => ({
  type: SELECT_ORGANIZATION,
  organizationKeyName,
});
